module.exports = __webpack_public_path__ + "static/media/it3.ffd2471c.svg";